import { render, staticRenderFns } from "./MyCoaches.vue?vue&type=template&id=6cbd2bd0&"
import script from "./MyCoaches.vue?vue&type=script&lang=js&"
export * from "./MyCoaches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports